/**
 * Danh sách report_id hỗ trợ tính năng Xem trước (preview grid).
 * Khi thi công báo cáo mới có preview, thêm report_id vào đây.
 */
export const REPORT_PREVIEW_SUPPORT_LIST = [
  'D67-THADS',
  'S08-THA',
  'b05_tha_asset_balance',
  'S05_THA',
  'B05-THA',
  // 'S03_THA',
  'S05H',
  // 'summary_voucher',
  // 'S01-THA-QT',
  // 's02_tha_so_cai_qt',
  // 'Payment_Advance_c07_Report_qd2030',
  // 'Payment_Advance_c07_Report',
  's08',
  'S01-THA',
  's09_tha',
  'statistics_of_accounting_documents',
  's02_tha_so_cai',
  'B04_THA_QT',
  'B04_THA',
  'B07_THA',
  'S06THA',
  'S04THA',
  'S07-THA',
  'S06-THA_QT',
];

export default {
  REPORT_PREVIEW_SUPPORT_LIST,
};
